import { render, staticRenderFns } from "./ProposalStepFooter.vue?vue&type=template&id=320f191c&scoped=true&"
import script from "./ProposalStepFooter.vue?vue&type=script&lang=js&"
export * from "./ProposalStepFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProposalStepFooter.vue?vue&type=style&index=0&id=320f191c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f191c",
  null
  
)

export default component.exports